module.exports = "/fonts/fa-solid-900.eot?e2675a616b68f446fa6284c111554c7f";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-solid-900.eot
// module id = dJCM
// module chunks = 0 1